import React from "react"

import * as S from "./featured-in-banner.styles"

const FeaturedInBanner = ({ title, logos }) => {
  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <S.TitleContainer>
          <S.Title>{title}</S.Title>
        </S.TitleContainer>
        <S.LogosContainer>
          {logos?.map(({ logo, link }, index) => (
            <a href={link} target="_blank" key={`${logo}-${index}`}>
              <S.Logo img={logo} />
            </a>
          ))}
        </S.LogosContainer>
      </S.Wrapper>
    </S.Section>
  )
}

export default FeaturedInBanner
